"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateBinaryOperator = exports.getBinaryOperatorString = exports.getBinaryOperator = exports.comparisonOperators = exports.BinaryOperator = void 0;
var errors_1 = require("../utils/errors");
/**
 * Binary mathematical operators, from lowest precedence (comparison operators) to highest (exponentiation).
 * 0 is not used as a raw value so all values are truthy.
 */
var BinaryOperator;
(function (BinaryOperator) {
    BinaryOperator[BinaryOperator["notEquals"] = -6] = "notEquals";
    BinaryOperator[BinaryOperator["equals"] = -5] = "equals";
    BinaryOperator[BinaryOperator["greaterThanOrEqual"] = -4] = "greaterThanOrEqual";
    BinaryOperator[BinaryOperator["greaterThan"] = -3] = "greaterThan";
    BinaryOperator[BinaryOperator["lessThanOrEqual"] = -2] = "lessThanOrEqual";
    BinaryOperator[BinaryOperator["lessThan"] = -1] = "lessThan";
    BinaryOperator[BinaryOperator["subtraction"] = 1] = "subtraction";
    BinaryOperator[BinaryOperator["addition"] = 2] = "addition";
    BinaryOperator[BinaryOperator["multiplication"] = 3] = "multiplication";
    BinaryOperator[BinaryOperator["modulus"] = 4] = "modulus";
    BinaryOperator[BinaryOperator["division"] = 5] = "division";
    BinaryOperator[BinaryOperator["exponentiation"] = 6] = "exponentiation";
})(BinaryOperator = exports.BinaryOperator || (exports.BinaryOperator = {}));
/**
 * The list of all logical comparison {@link BinaryOperator}s (i.e., those which compare two values and produce a boolean).
 */
exports.comparisonOperators = [
    BinaryOperator.notEquals,
    BinaryOperator.equals,
    BinaryOperator.greaterThanOrEqual,
    BinaryOperator.greaterThan,
    BinaryOperator.lessThanOrEqual,
    BinaryOperator.lessThan,
];
/**
 * Get the {@link BinaryOperator} represented by a string.
 * @param s The string containing an operator.
 * @returns The binary operator represented by the string, or {@code null} if there is operator for the given string.
 */
function getBinaryOperator(s) {
    switch (s) {
        case "^":
            return BinaryOperator.exponentiation;
        case "/":
            return BinaryOperator.division;
        case "%":
            return BinaryOperator.modulus;
        case "*":
            return BinaryOperator.multiplication;
        case "+":
            return BinaryOperator.addition;
        case "-":
            return BinaryOperator.subtraction;
        case "<":
            return BinaryOperator.lessThan;
        case "<=":
            return BinaryOperator.lessThanOrEqual;
        case ">":
            return BinaryOperator.greaterThan;
        case ">=":
            return BinaryOperator.greaterThanOrEqual;
        case "=":
            return BinaryOperator.equals;
        case "<>":
            return BinaryOperator.notEquals;
        default:
            return null;
    }
}
exports.getBinaryOperator = getBinaryOperator;
/**
 * Converts a {@link BinaryOperator} to its string form.
 * @param op The operator to convert
 * @returns The string representation of the operator
 */
function getBinaryOperatorString(op) {
    switch (op) {
        case BinaryOperator.exponentiation:
            return "^";
        case BinaryOperator.division:
            return "/";
        case BinaryOperator.modulus:
            return "%";
        case BinaryOperator.multiplication:
            return "*";
        case BinaryOperator.addition:
            return "+";
        case BinaryOperator.subtraction:
            return "-";
        case BinaryOperator.lessThan:
            return "<";
        case BinaryOperator.lessThanOrEqual:
            return "<=";
        case BinaryOperator.greaterThan:
            return ">";
        case BinaryOperator.greaterThanOrEqual:
            return ">=";
        case BinaryOperator.equals:
            return "=";
        case BinaryOperator.notEquals:
            return "<>";
    }
}
exports.getBinaryOperatorString = getBinaryOperatorString;
/**
 * Evaluates the given binary operator with the two values.
 *
 * Equals and not equals are the only two operators which accept non-numeric values.
 *
 * Passing non-numeric values with any other operator will throw an error.
 *
 * @param left The left hand side of the expression
 * @param operator The operator to apply
 * @param right The right hand side of the expression
 * @returns The result of the operator. Either a number or a boolean, depending on the operator (comparison operators
 *          produce booleans, arithmetic ones produce numbers).
 */
function evaluateBinaryOperator(left, operator, right) {
    if (operator !== BinaryOperator.equals && operator !== BinaryOperator.notEquals && (typeof left !== "number" || typeof right !== "number")) {
        throw new Error("Operator " + getBinaryOperatorString(operator) + " can only operate on numbers");
    }
    // todo: handle array equality comparisons
    switch (operator) {
        case BinaryOperator.subtraction:
            return left - right;
        case BinaryOperator.addition:
            return left + right;
        case BinaryOperator.multiplication:
            return left * right;
        case BinaryOperator.modulus:
            if (right === 0) {
                throw new errors_1.ArithmeticError("#DIV/0!");
            }
            return left % right;
        case BinaryOperator.division:
            if (right === 0) {
                throw new errors_1.ArithmeticError("#DIV/0!");
            }
            return left / right;
        case BinaryOperator.exponentiation:
            return Math.pow(left, right);
        case BinaryOperator.equals:
            // todo: use areValuesEqual function for this
            // todo: for floating point comparison, should this automatically compare using an epsilon?
            return left === right;
        case BinaryOperator.notEquals:
            return left !== right;
        case BinaryOperator.lessThan:
            return left < right;
        case BinaryOperator.lessThanOrEqual:
            return left <= right;
        case BinaryOperator.greaterThan:
            return left > right;
        case BinaryOperator.greaterThanOrEqual:
            return left >= right;
    }
}
exports.evaluateBinaryOperator = evaluateBinaryOperator;
//# sourceMappingURL=binaryOperator.js.map